import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { DashboardService } from 'utility/services/dashboard'
import { LoaderBar, EmptyBox, TileCard, CardBody, PaginationComponent } from 'components'
import { DashboardHeader } from 'components/DashboardHeader'
import { Grid, Message, Segment } from 'semantic-ui-react'
import { AppPrimaryButton } from 'elements'
import styled from 'styled-components'
import { useTabletAndBelowMediaQuery } from 'layout/ResponsiveMedia'

const CustomerListContainer = styled.div`
    padding: 1rem 1rem 1rem;
`

// header handled by shared DashboardHeader

// Title handled by DashboardHeader

// using Semantic UI Grid + shared TileCard instead of local list CSS

export const DashboardCustomerListScreen = () => {
    const navigate = useNavigate()
    const location = useLocation()
    useTabletAndBelowMediaQuery()
    const [customers, setCustomers] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const [customerGroup, setCustomerGroup] = useState(null)
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        pageSize: 20,
    })

    useEffect(() => {
        console.log('Location state:', location.state)
        if (location.state?.customerGroup) {
            setCustomerGroup(location.state.customerGroup)
            console.log('Setting customer group:', location.state.customerGroup)
            console.log('Group ID:', location.state.groupId)
            console.log('Selected group CustomerGroupId:', location.state.customerGroup.CustomerGroupId)
            fetchCustomers(location.state.customerGroup.CustomerGroupId)
        } else {
            navigate('/app/dashboard/groups')
        }
    }, [location.state, navigate])

    const fetchCustomers = async (customerGroupId, pageNumber = 1) => {
        try {
            setLoading(true)
            setError('')
            console.log('Fetching customers for groupId:', customerGroupId, 'page:', pageNumber)
            console.log('API URL will be:', `/Eauditor/Customer?PageNumber=${pageNumber}&PageSize=20&customerGroupId=${customerGroupId}`)

            const response = await DashboardService.getCustomersByGroup(
                customerGroupId,
                pageNumber,
                20,
            )
            console.log('Customers response:', response)
            console.log('Response Items:', response?.Items)
            console.log('Response TotalCount:', response?.TotalCount)

            // Filter customers to only show those from the selected group
            const allCustomers = response?.Items || []
            console.log('All customers from API:', allCustomers)
            console.log('Looking for CustomerGroupId:', customerGroupId)

            const filteredCustomers = allCustomers.filter(customer => {
                console.log(`Customer ${customer.customer_name} has CustomerGroupId: ${customer.CustomerGroupId}`)
                return customer.CustomerGroupId === customerGroupId
            })

            console.log('Filtered customers for group:', customerGroupId, filteredCustomers)
            setCustomers(filteredCustomers)

            // Update pagination state
            if (response?.MetaData) {
                setPagination({
                    currentPage: response.MetaData.CurrentPage || pageNumber,
                    totalPages: response.MetaData.LastPage || 1,
                    totalCount: response.MetaData.Total || 0,
                    pageSize: response.MetaData.PerPage || 20,
                })
            }
        } catch (err) {
            console.error('Error fetching customers:', err)
            setError('Failed to load customers')
        } finally {
            setLoading(false)
        }
    }

    const handleBackClick = () => {
        navigate('/app/dashboard/groups')
    }

    const handleCustomerGoClick = (customer) => {
        navigate('/app/dashboard/templates', {
            state: {
                customerGroup,
                customer,
                groupId: customerGroup?.CustomerGroupId,
            },
        })
    }

    if (loading) {
        return <LoaderBar content="Loading customers..." />
    }

    return (
        <CustomerListContainer>
                <DashboardHeader
                    title="Restaurant Excellence Visit"
                    showBack
                    onBack={handleBackClick}
                    showHome
                    onHome={() => navigate('/app/dashboard/groups')}
                />

                {error && <Message negative content={error} />}

                {customerGroup && (
                    <Segment>
                        <h3 style={{ margin: '0 0 0.5rem 0' }}>
                            {customerGroup.CustomerGroupName}
                        </h3>
                        <p style={{ margin: 0 }}>Available Customers</p>
                    </Segment>
                )}

                {customers.length > 0 ? (
                    <Grid stackable doubling columns={2} padded>
                        {customers.map((customer, index) => (
                            <Grid.Column key={customer.unique_id || customer.CustomerId || index}>
                                <TileCard onClick={() => handleCustomerGoClick(customer)}>
                                    <CardBody>
                                        <h4 style={{ margin: '0 0 0.5rem 0', color: '#2c3e50', fontSize: '1.2rem' }}>
                                            {customer.customer_name || customer.CustomerName || `Customer ${index + 1}`}
                                        </h4>
                                        <p style={{ margin: 0, color: '#6c757d', fontSize: '0.9rem' }}>
                                            {customer.Email && `Email: ${customer.Email}`}
                                            {customer.Email && customer.Phone && ' • '}
                                            {customer.Phone && `Phone: ${customer.Phone}`}
                                        </p>
                                        <AppPrimaryButton style={{ marginTop: '0.75rem' }}>Go →</AppPrimaryButton>
                                    </CardBody>
                                </TileCard>
                            </Grid.Column>
                        ))}
                    </Grid>
                ) : (
                    <EmptyBox text="No Customers Found" />
                )}

                {customers.length === 0 && !loading && <EmptyBox text="No Customers Found" />}

                {/* Pagination */}
                {pagination.totalPages > 1 && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                        <PaginationComponent
                            activePage={pagination.currentPage}
                            totalCount={pagination.totalCount}
                            pageSize={pagination.pageSize}
                            pageChanged={page => fetchCustomers(customerGroup?.CustomerGroupId, page)}
                        />
                    </div>
                )}
        </CustomerListContainer>
    )
}
